<div
  (clickOutside)="open ? toggleLeftSider() : null"
  #sider
  style="grid-template-rows: auto 1fr"
  class="border-start vh-100 border-light left-sidebar border-2"
>
  <div class="p-3">
    <span (click)="toggleLeftSider()" class="aya-arrow-left pointer"></span>
  </div>
  <ngx-simplebar
    class="px-3 position-sticky sticky-lg-top px-md-3"
    #componentRef
  >
    <div>
      <div class="py-4">
        <h5 class="mb-0 fw-bold">
          {{ 'LEFT_SIDEBAR.NOTIFICATIONS_TITLE' | translate }}
        </h5>
      </div>
      <div *ngIf="notification.length === 0" class="pb-4 text-center">
        {{ 'LEFT_SIDEBAR.NO_NOTIFICATIONS' | translate }}
      </div>
      <div class="mb-1 d-flex gap-2" *ngFor="let item of notification">
        <div>
          <div class="icon-box">
            <span class="aya-warning"></span>
          </div>
        </div>
        <div class="d-grid">
          <div
            [ngbTooltip]="item?.content"
            class="text-truncate fw-bold text-info"
          >
            <span>
              {{ item?.content }}
            </span>
          </div>
          <p>
            <small>
              {{ item?.date | date }}
            </small>
          </p>
        </div>
      </div>
    </div>
    <div>
      <div class="pb-4">
        <h5 class="mb-0 fw-bold">
          {{ 'LEFT_SIDEBAR.ACTIVITIES_TITLE' | translate }}
        </h5>
      </div>
      <div *ngIf="activities.length === 0" class="pb-4 text-center">
        {{ 'LEFT_SIDEBAR.NO_ACTIVITIES' | translate }}
      </div>
      <div class="mb-1 d-flex gap-2" *ngFor="let item of activities">
        <div>
          <div class="icon-box">
            <span class="aya-warning"></span>
          </div>
        </div>
        <div class="d-grid">
          <div
            [ngbTooltip]="item?.content"
            class="text-truncate fw-bold text-info"
          >
            <span>
              {{ item?.content }}
            </span>
          </div>
          <p>
            <small>
              {{ item?.date | date }}
            </small>
          </p>
        </div>
      </div>
    </div>
    <div>
      <div class="pb-4">
        <h5 class="mb-0 fw-bold">
          {{ 'LEFT_SIDEBAR.MESSAGES_TITLE' | translate }}
        </h5>
      </div>
      <div *ngIf="messages.length === 0" class="pb-4 text-center">
        {{ 'LEFT_SIDEBAR.NO_MESSAGES' | translate }}
      </div>
      <div class="mb-1 d-flex gap-2" *ngFor="let item of messages">
        <div>
          <div class="icon-box">
            <span class="aya-email small"></span>
          </div>
        </div>
        <div class="d-grid">
          <div
            [ngbTooltip]="item?.content"
            class="text-truncate fw-bold text-info"
          >
            <span>
              {{ item?.content }}
            </span>
          </div>
          <p>
            <small>
              {{ item?.date | date }}
            </small>
          </p>
        </div>
      </div>
    </div>
  </ngx-simplebar>

  <!--? ================================================= -->
</div>
